module.exports = __webpack_public_path__ + "img/playing.a2963e10.gif";